import React, { useContext, useEffect, useState } from 'react';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { FormContainer } from '../../common/form/FormContainer';
import { FormContext } from '../../common/form/FormContext';
import FormItem from '../../common/form/FormItem';
import FormPanel from '../../common/form/FormPanel';
import FormWidget from '../../common/form/FormWidget';
import I18n from '../../common/i18n/I18n';
import { arrayToSelectOptionsLocalized, SelectTypeEnum } from '../attributes';

export default (props) => {
    const [options, setOptions] = useState([]);
    const [isExistingTermset, setIsExistingTermset] = useState(true);
    const { setState } = useContext(FormContext);
    const { termsetsData } = props;

    useEffect(() => {
        setState((prevVal) => {
            if (!prevVal.selectType || prevVal.selectType.id !== SelectTypeEnum.single) {
                return {
                    ...prevVal,
                    selectType: {
                        id: SelectTypeEnum.single,
                        label: SelectTypeEnum.single,
                        reference: undefined
                    }
                };
            }
            return prevVal;
        });
    }, [setState]);

    useEffect(() => {
        if (termsetsData) {
            const options = termsetsData.termsets.map((ts) => {
                return {
                    id: ts.name,
                    label: ts.label
                };
            });
            setOptions(options);
        }
    }, [termsetsData]);

    return (
        <FormPanel>
            <FormContainer>
                <FormItem>
                    <FormWidget name="label" label={<I18n token="common.label" />} />
                </FormItem>
                <FormItem>
                    <FormWidget name="group" label={<I18n token="common.group" />} />
                </FormItem>
                <FormItem>
                    <FormWidget
                        name="description"
                        component={FORM_WIDGET_COMPONENTS.textArea}
                        label={<I18n token="common.description" />}
                    />
                </FormItem>
                <FormItem quarter>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.switch}
                        name="required"
                        label={<I18n token="common.required" />}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.switch}
                        name="keyInformation"
                        label={<I18n token="termset.label.key.information" />}
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.chips}
                        name="selectType"
                        coerceChangeToArray
                        options={arrayToSelectOptionsLocalized(Object.values(SelectTypeEnum))}
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.switch}
                        value={isExistingTermset}
                        onChange={() => {
                            setIsExistingTermset((prev) => !prev);
                        }}
                        label={<I18n token="termset.label.pick.existing" />}
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.autocomplete}
                        name="termset"
                        label={<I18n token="termset.label.existing" />}
                        options={options}
                        disabled={!isExistingTermset}
                        allowFreeForm
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        multiple
                        name="newTermset"
                        component={FORM_WIDGET_COMPONENTS.autocomplete}
                        label={<I18n token="termset.label.create.new" />}
                        allowFreeForm
                        disabled={isExistingTermset}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.switch}
                        name="allowCreate"
                        label={<I18n token="termset.label.allow.create" />}
                        disabled={isExistingTermset}
                    />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
};
